import BoxEditor from "@components/BoxEditor";
import ButtonContainer from "@components/ButtonContainer";
import IFaq from "@interfaces/faq";
import { ReactElement } from "react";

interface IDetailForm {
  data: IFaq;
}

const DetailForm = ({ data }: IDetailForm): ReactElement => (
  <form className="form">
    <div className="form__form-group">
      <span className="form__form-group-label">Question</span>
      <div className="form__form-group-field">
        <input type="text" value={data?.question} disabled />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">Answer</span>
      <div className="form__form-group-field">
        <BoxEditor body={data?.answer} />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">Order</span>
      <div className="form__form-group-field">
        <input type="text" value={data?.order} disabled />
      </div>
    </div>

    <ButtonContainer />
  </form>
);

export default DetailForm;
